import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class OpportunityScanResult extends Enum {
  key!: string;
  value!: string;

  static SUCCESS_NEW: OpportunityScanResult = {
    key: 'success_new',
    get value(): string {
      return Lang.t('opportunity.success-new-opportunities');
    }
  };

  static SUCCESS_NO_NEW: OpportunityScanResult = {
    key: 'success_no_new',
    get value(): string {
      return Lang.t('opportunity.success-no-new-opportunities');
    }
  };

  static UNSUCCESSFUL: OpportunityScanResult = {
    key: 'unsuccessful',
    get value(): string {
      return Lang.t('opportunity.unsuccessful-scan');
    }
  };

  static PENDING: OpportunityScanResult = {
    key: 'pending',
    get value(): string {
      return Lang.t('opportunity.pending-scan');
    }
  };

  static getSuccessfulResults(): string[] {
    return [OpportunityScanResult.SUCCESS_NEW.key, OpportunityScanResult.SUCCESS_NO_NEW.key];
  }
}
